module.exports = __webpack_public_path__ + "img/mbbr.9c3d5310.svg";